import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';


//点击添加按钮
export function addBySection({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ showModal: true, currentDataKey: null, customFormSubmitting: false, componentType: 'Create', title: uie.title, checkAll: false });
  pageComponent.formRef.current?.resetFields();
}

//点击编辑按钮
export function editBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ showModal: true, customFormSubmitting: false, componentType: 'Edit', title: uie.title, checkAll: false });
  pageComponent.formRef.current?.resetFields();
  httpClient
    .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
    .then(({ data }) => {
      if (data.result) {
        //把处理后的数据赋值给表单
        pageComponent.formRef.current?.setFieldsValue(data.data);
        pageComponent.setState({ currentDataKey: data.data.key });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}
